const saleType = {
    FixedPrice: 1,
    Percentage: 2,
};

const initMegaRule = {
    saleType: 0,
    saleValue: 0,
    minimumOrderValue: 0,
};

const ProcessOrderHelper = {
    calculateTotal: (order, ...discountFunctions) => {
        return discountFunctions.reduce((updatedOrder, discountFunction) => {
            return discountFunction(updatedOrder);
        }, order);
    },
    applyMegaSale:
        (megaRule = [initMegaRule]) =>
        (order) => {
            //tổng tiền hiện tại
            const totalSalePrice = order.totalSalePrice;

            //lấy ra deal hiện tại
            const currentMegaRule = megaRule.find((rule) => totalSalePrice >= rule.minimumOrderValue);

            //nếu không có deal nào thì trả về order ban đầu
            if (!currentMegaRule) {
                return order;
            }

            //tùy vào loại deal mà áp dụng giảm giá
            switch (currentMegaRule.saleType) {
                case saleType.FixedPrice:
                    return {
                        ...order,
                        finnallyPrice: totalSalePrice - currentMegaRule.saleValue,
                        discountCampaign: currentMegaRule.saleValue,
                        discounts: [
                            ...(order.discounts || []),
                            {
                                discountName: "Mega Sale",
                                discountType: saleType.FixedPrice,
                                discountValue: currentMegaRule.saleValue,
                                amount: currentMegaRule.saleValue,
                            },
                        ],
                    };
                case saleType.Percentage:
                    return {
                        ...order,
                        finnallyPrice: totalSalePrice - (totalSalePrice * currentMegaRule.saleValue) / 100,
                        discountCampaign: (totalSalePrice * currentMegaRule.saleValue) / 100,
                        discounts: [
                            ...(order.discounts || []),
                            {
                                discountName: "Mega Sale",
                                discountType: saleType.Percentage,
                                discountValue: currentMegaRule.saleValue,
                                amount: (totalSalePrice * currentMegaRule.saleValue) / 100,
                            },
                        ],
                    };
                default:
                    return order;
            }
        },
};

export default ProcessOrderHelper;
